

exports.__esModule = true;
exports.$PXPModel = undefined;
exports.$getPxpTreatments = $getPxpTreatments;
exports.$pxp = $pxp;
exports.$pxpMatch = $pxpMatch;
exports.$pxpFactors = $pxpFactors;

var _logger = require('xo-beaver/dist/logger');

var _core = require('../core');

var _locale = require('../locale');

var $PXPModel = exports.$PXPModel = _core.$Model.extend({
    api: new _core.$Api({
        uri: '/api/pxp/:pagename'
    })
});

function logPxp(pxpRes, params, logPayload) {

    var exp_name = [],
        xe = [],
        xt = [];

    angular.forEach(pxpRes.treatments, function (treatment) {

        _logger.$logger.info('treatment_' + treatment.treatment_name, angular.extend({
            experiment: pxpRes.id,
            treatment: treatment.treatment_name,
            experiment_id: treatment.experiment_id,
            treatment_id: treatment.treatment_id,
            loc_country: _locale.$locale.country,
            loc_lang: _locale.$locale.lang
        }, params, logPayload));

        exp_name.push(treatment.treatment_name);
        xe.push(treatment.experiment_id);
        xt.push(treatment.treatment_id);
    });

    _logger.$logger.info('pxp_' + pxpRes.id, angular.extend({
        pxp_exp_id: xe.join('|'),
        pxp_trtmnt_id: xt.join('|'),
        treatments: exp_name.join('|'),
        loc_country: _locale.$locale.country,
        loc_lang: _locale.$locale.lang
    }, params, logPayload));

    _logger.$logger.info('fpti_pxp_check', {
        from: 'PXP_CHECK',
        to: 'process_pxp_check',
        pxp_exp_id: xe.join(','),
        pxp_trtmnt_id: xt.join(','),
        txn_id: logPayload && logPayload.txn_id
    });

    _core.$event.emit('pxp_res', pxpRes);
}

function $getPxpTreatments(id, params, logPayload) {
    var forceApiCall = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];


    return _core.$promise.run(function () {

        var pxp = $PXPModel.instance(_core.$util.buildURL(id, params), { pagename: id });

        var forceTreatments = _core.$util.param('pxp_' + id);

        if (forceTreatments) {
            pxp.treatments = _core.$util.map(forceTreatments.split(','), function (treatment_name) {
                return {
                    treatment_name: treatment_name
                };
            });

            return pxp;
        }

        if (forceApiCall) {
            return pxp.reload({
                params: params
            });
        }

        return pxp.retrieve({
            params: params
        });
    }).then(function (pxp) {

        if (!pxp.cached) {
            logPxp(pxp, params, logPayload);
        }

        pxp.cached = true;

        return pxp;
    });
}

function $pxp(id, params, pattern) {
    var forceApiCall = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];


    if (!pattern) {
        pattern = params;
        params = {};
    }
    pattern = new RegExp('^' + pattern + '$');

    return $getPxpTreatments(id, params, null, forceApiCall).then(function (pxpResponse) {
        var result = void 0;
        _core.$util.some(pxpResponse.treatments, function (treatment) {
            if (pattern.test(treatment.treatment_name)) {
                result = {
                    treatment_name: treatment.treatment_name,
                    factors: treatment.factors
                };
                return result;
            }
        });
        return result;
    });
}

function $pxpMatch(id, params, patterns, logPayload) {

    if (!patterns) {
        patterns = params;
        params = {};
    }
    return $getPxpTreatments(id, params, logPayload).then(function (pxpResponse) {

        var result = {};

        angular.forEach(patterns, function (pattern, name) {
            pattern = new RegExp('^' + pattern + '$');

            result[name] = false;

            _core.$util.some(pxpResponse.treatments, function (treatment) {
                if (pattern.test(treatment.treatment_name)) {
                    result[name] = true;
                    return result[name];
                }
            });
        });

        return result;
    });
}

function $pxpFactors(id, params, pattern) {
    params.factors = 'true';
    return $pxp(id, params, pattern).then(function (pxpResponse) {
        var result = void 0;
        if (pxpResponse && pxpResponse.factors) {
            result = { treatment_name: pxpResponse.treatment_name };
            var pxpFactors = pxpResponse.factors;
            var length = pxpFactors.length;
            for (var i = 0; i < length; i++) {
                result[pxpFactors[i].name] = pxpFactors[i].value;
            }
        }
        return result;
    });
}

window.$pxp = $pxp;
angular.value("$PXPModel", $PXPModel);
angular.value("$getPxpTreatments", $getPxpTreatments);
angular.value("$pxp", $pxp);
angular.value("$pxpMatch", $pxpMatch);
angular.value("$pxpFactors", $pxpFactors);
_logger.$logger;

_core.$Model;

_core.$Api;

_core.$util;

_core.$promise;

_core.$event;

_locale.$locale;


/*****************
 ** WEBPACK FOOTER
 ** ./components/squid/dist/paypal/pxp.js
 ** module id = 147
 ** module chunks = 1
 **/